(() => {
  'use strict';

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const hydrateSecondaryImage = (card) => {
    const media = card?.querySelector('.cbh-card-media--has-secondary');
    if (!media || media.dataset.cbhSecondaryHydrated === '1') return;

    const template = media.querySelector('template[data-cbh-secondary-image]');
    if (!template) return;

    const fragment = template.content.cloneNode(true);
    const image = fragment.querySelector('.cbh-card__secondary-image');
    if (!image) return;

    media.dataset.cbhSecondaryHydrated = '1';
    media.appendChild(fragment);
    template.remove();

    const markReady = () => media.classList.add('cbh-card-media--secondary-ready');
    if (image.complete && image.naturalWidth > 0) markReady();
    else image.addEventListener('load', markReady, { once: true });
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      if (!finePointer.matches) return;
      const card = event.target.closest('.product-card-wrapper');
      if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
      hydrateSecondaryImage(card);
    },
    { passive: true }
  );

  let ratingHydrationTimer = 0;
  let ratingHydrationRetries = 0;

  const hasCardRatingWidgets = (root = document) =>
    !!root.querySelector?.('.product-card-wrapper .lipscore-rating-small, .product-card-wrapper .lipscore-review-count');

  const hydrateCardRatings = () => {
    ratingHydrationTimer = 0;
    if (!hasCardRatingWidgets()) {
      ratingHydrationRetries = 0;
      return;
    }

    try {
      if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
        window.lipscore.initWidgets();
        ratingHydrationRetries = 0;
        return;
      }
      if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') {
        window.lipscore.reInitWidgets(true);
        ratingHydrationRetries = 0;
        return;
      }
      if (typeof window.lipscoreInit === 'function') {
        window.lipscoreInit();
        ratingHydrationRetries = 0;
        return;
      }
    } catch (_) {}

    if (ratingHydrationRetries < 3) {
      ratingHydrationRetries += 1;
      ratingHydrationTimer = window.setTimeout(hydrateCardRatings, 250 * ratingHydrationRetries);
    } else {
      ratingHydrationRetries = 0;
    }
  };

  const scheduleRatingHydration = (delay = 40) => {
    window.clearTimeout(ratingHydrationTimer);
    ratingHydrationTimer = window.setTimeout(hydrateCardRatings, delay);
  };

  const start = () => {
    if (document.querySelector('product-recommendations .product-card-wrapper')) scheduleRatingHydration();

    document.addEventListener('cbh:product-recommendations:updated', () => scheduleRatingHydration());
    document.addEventListener('shopify:section:load', (event) => {
      if (hasCardRatingWidgets(event.target || document)) scheduleRatingHydration();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
